// components/tabs/DiagnosticsTab.jsx
// 模型诊断: 4 个指标卡 + parity plot + residual histogram + model card

import ParityPlot from '../viz/ParityPlot';
import ResidualHistogram from '../viz/ResidualHistogram';
import { useSolPred } from '../../hooks/useSolPredStore';

export default function DiagnosticsTab() {
  const { diag } = useSolPred();

  if (!diag) {
    return (
      <div className="canvas-card" style={{ textAlign: 'center', padding: 60 }}>
        <div style={{ fontSize: 36, marginBottom: 12 }}>⚠</div>
        <div style={{ fontSize: 14, color: 'var(--text-2)', marginBottom: 6 }}>
          该体系尚未训练模型
        </div>
        <div style={{ fontSize: 11, color: 'var(--text-3)' }}>
          暂无诊断数据可显示
        </div>
      </div>
    );
  }

  return (
    <div className="fade-in" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div className="diag-summary">
        <div className="metric-card success">
          <div className="metric-label">Validation R²</div>
          <div className="metric-value">{diag.r2}</div>
          <div className="metric-sub">越接近 1 越好</div>
        </div>
        <div className="metric-card">
          <div className="metric-label">MAE</div>
          <div className="metric-value">{diag.mae}</div>
          <div className="metric-sub">平均绝对误差 · wt</div>
        </div>
        <div className="metric-card warn">
          <div className="metric-label">RMSE</div>
          <div className="metric-value">{diag.rmse}</div>
          <div className="metric-sub">均方根误差</div>
        </div>
        <div className="metric-card violet">
          <div className="metric-label">N_test</div>
          <div className="metric-value">{diag.n}</div>
          <div className="metric-sub">测试样本数</div>
        </div>
      </div>

      <div className="diag-grid">
        <div className="canvas-card">
          <div className="canvas-header">
            <div>
              <div className="canvas-title">奇偶图 · Parity Plot</div>
              <div className="canvas-subtitle">实验值 vs 预测值 · 虚线 y=x · 绿色 ±10% 误差带</div>
            </div>
          </div>
          <ParityPlot diag={diag} />
        </div>
        <div className="canvas-card">
          <div className="canvas-header">
            <div>
              <div className="canvas-title">残差分布 · Residual Histogram</div>
              <div className="canvas-subtitle">残差应近似服从零均值正态分布</div>
            </div>
          </div>
          <ResidualHistogram diag={diag} />
        </div>
      </div>

      <div className="canvas-card">
        <div className="canvas-header">
          <div>
            <div className="canvas-title">模型卡 · Model Card</div>
            <div className="canvas-subtitle">PC-CVAE · Gibbs 自由能约束变分自编码器</div>
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 24, fontSize: 12 }}>
          <div>
            <div style={{ fontWeight: 700, marginBottom: 8, color: 'var(--text)' }}>架构</div>
            <div style={{ fontFamily: "'JetBrains Mono', monospace", color: 'var(--text-2)', lineHeight: 1.7 }}>
              Encoder: [w₁,w₂,T] → μ,σ ∈ ℝ⁸<br/>
              Decoder: z ∈ ℝ⁸ → [w₁_sat, w₂_sat]<br/>
              Latent dim: 8 · Hidden: 64-128<br/>
              Loss: MSE + KL + Gibbs penalty
            </div>
          </div>
          <div>
            <div style={{ fontWeight: 700, marginBottom: 8, color: 'var(--text)' }}>训练配置</div>
            <div style={{ fontFamily: "'JetBrains Mono', monospace", color: 'var(--text-2)', lineHeight: 1.7 }}>
              Optimizer: AdamW (lr=3e-4)<br/>
              Batch: 64 · Epochs: 800<br/>
              Train/Val/Test: 70/15/15<br/>
              Weight: ~320 KB · Inference: &lt;100 ms
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
